var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col flex-grow gap-4" },
    [
      _c(
        "samc-tab-set",
        { attrs: { value: _setup.tab }, on: { setValue: _setup.setValue } },
        [
          _c(
            "samc-tab",
            { attrs: { value: "assigned" } },
            [
              _vm._v("\n      Assigned To Me "),
              _setup.watchingCount >= 0
                ? _c("samc-tag", { staticClass: "ml-1" }, [
                    _vm._v(_vm._s(_setup.assignedCount)),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "samc-tab",
            { attrs: { value: "watching" } },
            [
              _vm._v("\n      Watching "),
              _setup.watchingCount >= 0
                ? _c("samc-tag", { staticClass: "ml-1" }, [
                    _vm._v(_vm._s(_setup.watchingCount)),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _setup.user !== null && _setup.tab === "assigned"
        ? _c("tm-task-grid", {
            key: "assigned-grid",
            ref: "assignedGrid",
            staticClass: "flex-grow",
            attrs: {
              token: _vm.verificationToken,
              "api-root": _vm.apiRoot,
              jwt: _setup.token,
              "current-user": _setup.user,
            },
            on: {
              getentityname: _setup.onGetEntityName,
              entityclick: _setup.onEntityClick,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.user !== null && _setup.tab === "watching"
        ? _c("tm-task-grid", {
            key: "watching-grid",
            ref: "watchingGrid",
            staticClass: "flex-grow",
            attrs: {
              token: _vm.verificationToken,
              "api-root": _vm.apiRoot,
              jwt: _setup.token,
              "current-user": _setup.user,
            },
            on: {
              getentityname: _setup.onGetEntityName,
              entityclick: _setup.onEntityClick,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }